import * as DG from "ui/dialogs"
import { ChangeEvent, useState } from "react"

import { queryCache, useMutation, useQuery } from "react-query"

import Button from "ui/buttons/Button"
import Options from "components/inputs/Options"
import { createBaseRate } from "api/ratecard"
import { fetchMediaTypeChannels } from "api/globalMediaTypes"
import { useI18n } from "providers/I18n"

type CreateChannelModalProps = {
  open: boolean
  onClose: () => void
  //
  rateCardId: string
  supplierId: string
  mediaTypeId: string
  //
  used: string[]
}

export function CreateChannelModal(props: CreateChannelModalProps) {
  const { open, onClose, supplierId, mediaTypeId, rateCardId, used } = props
  const { t } = useI18n()
  const [vendorProduct, setVendorProduct] = useState<string>(() => "")

  const ps = new URLSearchParams({ supplierId, mediaTypeId })

  const { data: products } = useQuery(
    ["supplies-products-options", ps.toString()],
    fetchMediaTypeChannels,
    { enabled: Boolean(supplierId) && Boolean(mediaTypeId) && open },
  )

  const [mu, result] = useMutation(createBaseRate)

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const v = evt.target.value
    setVendorProduct(v)
  }

  const handleSubmit = () => {
    mu({ rateCardId, supplierProductId: vendorProduct })
      .then(() => {
        queryCache.invalidateQueries(["rate-card-details", rateCardId])
      })
      .then(() => {
        onClose()
      })
  }

  const options =
    products
      ?.filter((x) => !used.includes(x.id))
      .map((x) => ({ value: x.id, label: x.name })) ?? []

  const NO_OPTIONS = options.length === 0
  const id = "create-channel-modal"

  return (
    <DG.Dialog open={open} onClose={onClose} id={id}>
      <DG.DialogHeader>
        <DG.DialogTitle id={id}>
          {t("rate.card.vendorProduct.add.title")}
        </DG.DialogTitle>
        <DG.DialogClose onClose={onClose} />
      </DG.DialogHeader>

      <DG.DialogContent center paddingTop>
        <div>
          <Options
            value={vendorProduct}
            onChange={handleChange}
            options={options}
            name="vendorProduct"
            label="Vendor Product"
          />
        </div>
      </DG.DialogContent>
      <DG.DialogFooter>
        <DG.DialogActions>
          <Button variant="outlined" color="primary" onClick={onClose}>
            {t("actions.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={NO_OPTIONS || !vendorProduct || result.isLoading}
            onClick={handleSubmit}
          >
            {t("actions.submit")}
          </Button>
        </DG.DialogActions>
      </DG.DialogFooter>
    </DG.Dialog>
  )
}
